// Case insensitive compare
const stringCompare = new Intl.Collator(undefined, { sensitivity: 'base' }).compare;
const valueCompare = (a, b) => {
  if (typeof a === 'string' && typeof b === 'string') return stringCompare(a, b);
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

export function dynamicSort(property) {
  if (!property) return valueCompare;
  let sortOrder = 1;
  let sortProp = property;
  if (sortProp[0] === '-') {
    sortOrder = -1;
    sortProp = sortProp.substr(1);
  }

  return (a, b) => {
    const result = valueCompare(a[sortProp], b[sortProp]);

    return result * sortOrder;
  };
}

export function dynamicSortMultiple(...props) {
  const sortFunctions = props.map(dynamicSort);
  const numberOfProperties = sortFunctions.length;

  return (obj1, obj2) => {
    let i = 0;
    let result = 0;
    while (result === 0 && i < numberOfProperties) {
      result = sortFunctions[i](obj1, obj2);
      i += 1;
    }

    return result;
  };
}
// array.sort(dynamicSortMultiple("prop1", "prop2"))
